import React from 'react';
import i18next from 'i18next';
import { observer } from 'mobx-react';
import { Dropdown, Icon } from 'components';
import {
  DropdownWrapper,
  dropItemStyle,
  dropTriggerStyle,
  placeholderStyle,
} from '../common';

export type ProjectSortByProps = {
  noSort?: boolean;
  projectsConn: any;
};

export const ProjectSortBy = observer(
  ({ projectsConn, noSort }: ProjectSortByProps) => {
    const { sortOptions } = projectsConn || {};

    const sectionSortIndex =
      projectsConn?.sortOptions?.findIndex(
        ([optionValue]: [any]) => optionValue === projectsConn.sortBy,
      ) || 0;

    if (noSort) return null;

    return (
      <DropdownWrapper>
        {sortOptions && sortOptions.length > 0 && (
          <Dropdown
            dropItemStyle={dropItemStyle}
            size='small'
            dropTriggerStyle={dropTriggerStyle}
            placeholderStyle={placeholderStyle}
            items={sortOptions.map((opt: string[]) => ({
              text: opt[1],
              key: opt[0],
              value: opt[0],
            }))}
            trigger={
              <span
                className='inline-block mr-1'
                style={{
                  color: '#777',
                }}
              >
                {i18next.t('Sort By')}:
              </span>
            }
            iconRight={
              <Icon size='0.75em' name='caret_down' colorPath='#777' />
            }
            placeholder={sortOptions[0][1]}
            selectedItemIndex={sectionSortIndex}
            onItemSelected={(sortOption: { value: string }) =>
              projectsConn.SetSort(sortOption.value)
            }
          />
        )}
      </DropdownWrapper>
    );
  },
);
